/** Human-readable package line for admin booking views (BUG-026). */
export function resolveBookingPackageLabel(booking) {
  if (!booking) return 'N/A';

  let cd = booking.customizedData || {};
  if (!cd.productLine && typeof booking.customizedDataJson === 'string') {
    try {
      const parsed = JSON.parse(booking.customizedDataJson);
      cd = { ...parsed, ...cd };
    } catch {}
  }
  const line = (cd.productLine || booking.productLine || '').trim();
  const sourceName = cd.sourcePackageName || cd.packageTitle || cd.packageName;
  const explicit = booking.packageName;

  // Build locations route string if available
  const locs = [
    booking.firstEntryLocation || cd.stays?.firstEntry?.location,
    booking.secondEntryLocation || cd.stays?.secondEntry?.location,
    booking.thirdEntryLocation || cd.stays?.thirdEntry?.location,
  ].filter(Boolean);
  const routeStr = locs.length ? ` (${locs.join(' → ')})` : '';

  if (sourceName) {
    if (line === 'Domestic' || line === 'Local') {
      return sourceName.includes('Domestic') ? sourceName : `${sourceName} (Domestic)`;
    }
    return sourceName;
  }

  const isUmrahPlaceholder = !explicit || /^(umrah\s*package)$/i.test(explicit.trim());

  if (line === 'Domestic' || line === 'Local') {
    if (cd.packageType) return `Domestic package — ${cd.packageType}${routeStr}`;
    if (explicit && !isUmrahPlaceholder) return explicit;
    return `Domestic Customized Package${routeStr}`;
  }

  if (line === 'International') {
    if (explicit && !isUmrahPlaceholder) return explicit;
    return `International Customized Trip${routeStr}`;
  }

  if (line === 'Umrah') {
    return explicit || `Umrah Customized Package${routeStr}`;
  }

  if (booking.isCustomizedPackage) {
    if (explicit && !isUmrahPlaceholder) return explicit;
    return `Customized Package${routeStr}`;
  }

  return explicit || 'N/A';
}